<template>
  <div class="container py-5">
    <JobDescriptionHeader
        title="شایستگی‌های مورد انتظار"
        description="در این بخش می‌توانید وضعیت توانایی‌ها، وضعیت مهارت‌ها و سطح شایستگی‌های مورد انتظار را تعیین کنید"
    />

    <div class="row mt-4">
      <div class="col-md-12">
        <AbilitiesSection/>
      </div>
      <div class="col-md-12">
        <SkillsSection/>
      </div>
      <div class="col-md-12">
        <CompetenciesSection :competencies="competencies" />
      </div>
      <div class="col-md-12">
        <div class="alert alert-info mt-2">
          <h4 class="alert-heading">توجه:</h4>
          <p class="fs-sm">اگر نیاز دارید شایستگی جدیدی ایجاد کنید، لطفاً به صفحه <router-link to="/processes" class="alert-link">فرآیندها</router-link> مراجعه کنید و از آنجا اقدام نمایید.</p>
        </div>
      </div>
    </div>

    <div class="row mt-4">
    </div>

    <NavigationButtons @next="$emit('next')" @prev="$emit('prev')" />
  </div>
</template>

<script>
import NavigationButtons from "@/components/JobDescription/GeneralComponents/NavigationButtons.vue";
import JobDescriptionHeader from "@/components/JobDescription/GeneralComponents/JobDescriptionHeader.vue";
import CompetenciesSection from "@/components/JobDescription/StepFive/CompetenciesSection.vue";
import AbilitiesSection from "@/components/JobDescription/StepFive/AbilitiesSection.vue";
import SkillsSection from "@/components/JobDescription/StepFive/SkillsSection.vue";

export default {
  components: {
    SkillsSection,
    AbilitiesSection,
    CompetenciesSection,
    JobDescriptionHeader,
    NavigationButtons
  },
  created() {
    this.$store.dispatch('competencies/fetchCompetencies')
  },
  computed: {
    competencies() {
      return this.$store.state.competencies.competencies;
    },
  }
};
</script>